import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Button, Icon, Loader } from "semantic-ui-react";
import { getCompanyServiceType } from "../../api/companyServicesType";
import { ICompanyServiceType } from "../../models/companyServiceType";
import { EditCompanyServiceType } from "./EditCompanyServiceType";

export const CompanyServiceTypeDetails = () => {
    const params: { guid: string } = useParams();
    const loc = useLocation();
    const [loading, setLoading] = useState(true);
    const [companyServiceType, setCompanyServiceType] = useState<ICompanyServiceType>();

    const fetchCompanyServiceType = useCallback(async (guid: string) => {
        setLoading(true);
        const res = await getCompanyServiceType(guid);
        res.guid && setCompanyServiceType(res);
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchCompanyServiceType(params.guid);
    }, [fetchCompanyServiceType, params.guid]);

    return loading ? (
        <Loader active inline="centered" size="huge" />
    ) : (
        <div className="company-service-type-container">
            <div className="container-header">
                <h1>Service type details</h1>
                <Button
                    as={Link}
                    to={{ pathname: "/administration/settings", state: loc.state }}
                    secondary
                    content="Back to list"
                    icon="arrow left"
                />
            </div>
            {companyServiceType ? (
                <EditCompanyServiceType
                    companyServiceType={companyServiceType}
                    setCompanyServiceType={setCompanyServiceType}
                />
            ) : (
                <h2 style={{ textAlign: "center" }}>
                    <Icon name="warning circle" />
                    Company service type not found
                </h2>
            )}
        </div>
    );
};
